import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { InsuranceInsuredPerson } from '../../../../model/types'

import s from './styles.module.scss'

interface ParticipantItemProps {
  number: number
  participant: InsuranceInsuredPerson
}

export const ParticipantItem: FC<ParticipantItemProps> = ({
  number,
  participant,
}) => {
  const { t } = useTranslation()
  const rows = [
    {
      label: t('insurance.vzr.participants_details.birth_date'),
      value: participant.birthDate,
    },
    {
      label: t('insurance.vzr.participants_details.passport'),
      value: participant.passportNumber,
    },
    {
      label: t('insurance.vzr.participants_details.citizenship'),
      value: participant.citizenship,
    },
  ]

  return (
    <li className={s.item}>
      <AppIcon
        id={AllIcons.INSURANCE_CALCULATION_PARTICIPANTS}
        width={24}
        height={24}
        className={s.icon}
      />
      <div className={s.content}>
        <p className={clsx(s.caption, 'regular-12')}>
          {t('insurance.vzr.participants_details.participant', { number })}
        </p>
        <p className={clsx(s.name, 'medium-14')}>{participant.fullName}</p>
        {rows.map(({ label, value }) => (
          <p
            key={label}
            className={clsx(s.row, 'regular-13')}
          >
            {label} {value || '—'}
          </p>
        ))}
      </div>
    </li>
  )
}
